import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import Light from "./headers/light";
import Footerr from "./footers/Footer";
import Swal from "sweetalert2";

const ResetPassword = () => {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const navigate = useNavigate();

 const handleSubmit = async (e) => {
    e.preventDefault();
    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get("token");
    const email = urlParams.get("email");

    if (password !== confirmPassword) {
      Swal.fire({
        icon: "warning",
        title: "Les mots de passe ne correspondent pas.",
      });
      return;
    }

    try {
      const response = await axios.post("https://plateformewmg.cloud/api/password/reset", {
        email,
        password,
        password_confirmation: confirmPassword,
        token,
      });

      Swal.fire({
        icon: "success",
        title: "Succès",
        text: response.data.message,
        timer: 1500,
        showConfirmButton: false,
      });

      setTimeout(() => navigate("/login"), 1600);

    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Erreur",
        text: error.response?.data?.message || "La réinitialisation du mot de passe a échoué.",
      });
    }
  };
 
  return (
<AnimationRevealPage>
      <Light />

    <div className="container d-flex justify-content-center align-items-center vh-100">
    <div className="card shadow p-4" style={{ maxWidth: "400px", width: "100%" }}>
      <h2 className="text-center mb-3">Reset Password</h2>
      <form onSubmit={handleSubmit}>
        <div className="mb-3">
          <input
            type="password"
            className="form-control"
            placeholder="New Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>
        <div className="mb-3">
          <input
            type="password"
            className="form-control"
            placeholder="Confirm Password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            required
          />
        </div>
        <button type="submit" className="btn btn-primary w-100">Reset Password</button>
      </form>
    </div>
  </div>
  <Footerr />
    </AnimationRevealPage>

  );
};

export default ResetPassword;
